<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900" scrollable>
			<v-card>
				<v-card-title class="text-h6">
					<span>Detail Pemesanan</span>
					<span class="pl-2 font-weight-bold">{{detailPO.po_code}}</span>
				</v-card-title>
				<v-card-text class="black--text">
					<v-row class="mb-2">
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold">Data Warehouse</div>
							<div class="pt-1">{{ detailPO.warehouse_name }}</div>
							<div class="pt-1">{{ detailPO.warehouse_mobilephone }}</div>
							<div class="pt-1">
								{{addressText(detailPO)}}
							</div>
						</v-col>
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold">Status Pembayaran</div>
							<v-col cols="6" class="mt-1 pa-0">
								<div v-if="detailPO.po_payment_method == 'lunas'" class="cyan darken-2 rounded caption text-uppercase white--text pa-2 d-flex justify-center">
									<span class="mr-2"><v-icon dense color="white">mdi-check-circle</v-icon></span>
									<span class="mr-2">{{detailPO.po_payment_method}}</span>
								</div>
								<div v-else class="orange rounded caption text-uppercase white--text pa-2 d-flex justify-center">
									<span><v-img width="15" class="mr-2" src="/assets/icon/tempo-icon.png"></v-img></span>
									<span class="mr-2">{{detailPO.po_payment_method}}</span>
								</div>
								<!-- <div v-if="detailPO.po_payment_method == 'lunas'" class="cyan darken-2 rounded text-subtitle-1 text-uppercase white--text text-center text-uppercase font-weight-bold pa-2 d-flex justify-center">
									<v-icon color="white">mdi-check-circle</v-icon>
									<div class="pl-3">{{ detailPO.po_payment_method }}</div>
								</div>
								<div v-else class="orange rounded text-subtitle-1 text-uppercase white--text text-center text-uppercase font-weight-bold pa-2 d-flex justify-center">
									<span><v-img width="15" class="mt-1" src="/assets/icon/tempo-icon.png"></v-img></span>
									<span class="pl-3">{{detailPO.po_payment_method}}</span>
								</div> -->
							</v-col>
							<div class="text-subtitle-1 mt-3 font-weight-bold">Catatan</div>
							<v-col cols="12" class="pa-0">
								<div class="pt-1">{{detailPO.po_note ? detailPO.po_note : '-'}}</div>
							</v-col>
						</v-col>
					</v-row>
					<v-list dense color="grey lighten-3" class="pa-1 mb-2" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase cyan--text text--darken-2">detail produk</div>
						</v-list-item>
					</v-list>
					<v-card class="mb-5 elevation-0">
						<v-data-table dense :headers="headers" :items="detailPO.po_detail" hide-default-footer>
							<template v-slot:item.po_detail_quantity_approved="{ item }">
								<div>{{ item.po_detail_quantity_approved | toNumber }}</div>
							</template>
							<template v-slot:item.po_detail_quantity_delivered="{ item }">
								<div>{{ item.po_detail_quantity_delivered | toNumber }}</div>
							</template>
							<template v-slot:item.po_detail_quantity_transport="{ item }">
								<div>{{ item.po_detail_quantity_transport | toNumber }}</div>
							</template>
						</v-data-table>
					</v-card>
					<v-list color="grey lighten-3" class="pa-1 mb-2" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">Jadwal Pengiriman</div>
						</v-list-item>
					</v-list>
					<div v-if="Object.values(poSchedules).length > 0">
						<v-row class="mb-2">
							<v-col cols="6" md="6" v-for="(a, index) in poSchedules" :key="index">
								<v-card class="mb-5 elevation-0" outlined >
									<v-card-title class="text-body-2 font-weight-bold cyan darken-2">
										<span class="white--text">{{index | haritanggal}}</span>
									</v-card-title>
									<v-data-table dense :headers="scheduleHeaders" :items="a" hide-default-footer>
										<template v-slot:item.product_name="{ item }">
											<div>{{ convertMaxLength(item.product_name) }}</div>
										</template>
										<template v-slot:item.po_schedule_detail_quantity="{ item }">
											<div>{{ item.po_schedule_detail_quantity | toNumber }}</div>
										</template>
									</v-data-table>
								</v-card>
							</v-col>
						</v-row>
					</div>
					<div v-else>
						<not-found-cyan></not-found-cyan>
					</div>
					<v-list color="grey lighten-3" class="pa-1 mb-2" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase cyan--text text--darken-2">status pemesanan</div>
						</v-list-item>
					</v-list>
					<v-row class="mb-2" v-if="detailPO.po_status_closed_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailPO.po_status == 'closed' ? 'cyan darken-2' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-2">{{'closed' | toStatusPOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailPO.po_status_closed_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-2" v-if="detailPO.po_status_supp_processed_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailPO.po_status == 'supp_processed' ? 'cyan darken-2' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-2">{{'supp_processed' | toStatusPOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailPO.po_status_supp_processed_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-2" v-if="detailPO.po_status_supp_approved_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailPO.po_status == 'supp_approved' ? 'cyan darken-2' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-2">{{'supp_approved' | toStatusPOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailPO.po_status_supp_approved_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-2" v-if="detailPO.po_status_supp_rejected_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailPO.po_status == 'supp_rejected' ? 'cyan darken-2' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-2">{{'supp_rejected' | toStatusPOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailPO.po_status_supp_rejected_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-2" v-if="detailPO.po_status_wh_approved_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailPO.po_status == 'wh_approved' ? 'cyan darken-2' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-2">{{'wh_approved' | toStatusPOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailPO.po_status_wh_approved_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-2" v-if="detailPO.po_status_wh_rejected_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailPO.po_status == 'wh_rejected' ? 'cyan darken-2' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-2">{{'wh_rejected' | toStatusPOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailPO.po_status_wh_rejected_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-2" v-if="detailPO.po_status_created_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailPO.po_status == 'created' ? 'cyan darken-2' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-2">{{'created' | toStatusPOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{ detailPO.po_status_created_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>

				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideDialog">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			singleSelect: false,
			selected: [],
			headers: [
			{ text: 'Nama Produk', value: 'po_detail_supplier_product_name'},
			{ text: 'Jumlah Pesanan', value: 'po_detail_quantity_approved', align: 'center'},
			{ text: 'Jumlah Dikirim', value: 'po_detail_quantity_transport', align: 'center'},
			{ text: 'Jumlah Diterima', value: 'po_detail_quantity_delivered', align: 'center'},
			],
			scheduleHeaders: [
			{ text: 'Nama Produk', value: 'supplier_product_name', sortable: false, width: '55%'},
			{ text: 'Kode Produk', value: 'supplier_product_code', sortable: false, width: '25%'},
			{ text: 'Jumlah', value: 'po_schedule_detail_quantity', sortable: false, align: 'center', width: '20%'},
			],
		}
	},
	computed:{
		...mapState('poSupplier', ['detailPO']),

		poSchedules() {
			let schedule = []
			if (this.detailPO.po_schedules) {
				schedule = this.detailPO.po_schedules.reduce((r, a) => {
					r[a.po_schedule_detail_date] = [...r[a.po_schedule_detail_date] || [], a];
					return r;
				}, {});
			}
			return schedule
		}
	},
	props: {
		dialog: Boolean
	},
	methods :{
		hideDialog(){
			this.$emit('hideDialog')
		},
		convertMaxLength(value) {
			if (value.length > 26)
				value = value.slice(0, 25) + '...'
			return value
		},
		addressText(warehouse) {
			var data = []
			if (warehouse) {
				if (warehouse.warehouse_address)
					data.push(warehouse.warehouse_address)
				if (warehouse.warehouse_subdistrict_name)
					data.push(warehouse.warehouse_subdistrict_name)
				if (warehouse.warehouse_city_name)
					data.push(warehouse.warehouse_city_name)
				if (warehouse.warehouse_province_name)
					data.push(warehouse.warehouse_province_name)
			}
			return data.join(', ')
		},
	}
};
</script>
